export const setIntro = (id) => {
    return {
        type: 'SET_INTRO',
        id
    }
}


// WEBPACK FOOTER //
// ./src/actions/intro.js